module.exports = __webpack_public_path__ + "img/Logo_Horitzontal_Negre.bc26f14e.png";